import { EventsFromTopLeaguesBySportIdRequest, EventsBySportIdRequest, } from "../../contracts";
import { compareArrays } from "../compareArrays";
import { getUniqueNotEmptyElements } from "../getUniqueNotEmptyElements";
import { getSortParam } from "../getSortParam";
export const requestBuilder = {
    buildSportIdsUpdate(params, sportIds, shouldBuildSort, shouldChangeMarketIds) {
        this.buildIds(params.request, sportIds);
        this.buildEventTags(params.request);
        shouldChangeMarketIds && this.buildMarketIdsByType(params, sportIds);
        this.buildSort(params.request, shouldBuildSort, getSortParam());
    },
    buildDateRangeUpdate(params, dateRange, shouldBuildSort, shouldChangeMarketIds, tags = []) {
        this.buildDateRange(params.request, dateRange);
        this.buildEventTags(params.request, tags);
        shouldChangeMarketIds && this.buildMarketIdsByType(params, params.request.sportIds || params.request.ids);
        this.buildSort(params.request, shouldBuildSort, getSortParam());
    },
    buildLeagueIdsUpdate(params, leagueIds, sportIds, shouldChangeMarketIds) {
        this.buildIds(params.request, leagueIds);
        shouldChangeMarketIds && this.buildMarketIdsByType(params, sportIds);
    },
    buildRegionIdUpdate(params, regionId, sportId, pagination, shouldChangeMarketIds) {
        this.buildSportId(params.request, sportId);
        this.buildRegionId(params.request, regionId);
        shouldChangeMarketIds && this.buildMarketIdsByType(params);
        this.buildPagination(params.request, pagination);
    },
    buildEventTagsUpdate(params, eventTags, shouldBuildSort) {
        this.buildIds(params.request, params.allSportIds);
        this.buildEventTags(params.request, eventTags);
        this.buildMarketIdsByType(params, params.request.sportIds || []);
        this.buildSort(params.request, shouldBuildSort, getSortParam());
    },
    buildEventIdsUpdate(params, favoriteEvents) {
        this.buildIds(params.request, favoriteEvents.map(ev => ev.eventId));
        this.buildMarketIdsByType(params, favoriteEvents.map(ev => ev.sportId).filter((id, i, array) => array.indexOf(id) === i));
    },
    buildSportIdRequest(request, pagination) {
        const result = Object.assign({}, request);
        this.buildExcludeRegionIds(result, request.regionIds);
        this.buildRegionIds(result, undefined);
        this.buildLeagueState(result, EventsBySportIdRequest.LeagueStateEnum.Regular);
        this.buildPagination(result, pagination);
        return result;
    },
    buildPersonalizedEventsRequest(request, sportIds) {
        this.buildIds(request, sportIds);
        const result = Object.assign({}, request);
        return result;
    },
    buildEventsGoingLiveUpdate(params, sportIds, shouldBuildSort, shouldChangeMarketIds, tags = []) {
        this.buildSportIds(params.request, sportIds);
        this.buildSort(params.request, shouldBuildSort, getSortParam());
        if (shouldChangeMarketIds) {
            this.buildMarketIdsByType(params, sportIds);
        }
        this.buildEventTags(params.request, tags);
    },
    buildPagination(request, pagination) {
        request.pagination = pagination;
    },
    buildLeagueState(request, leagueState) {
        request.leagueState = leagueState;
    },
    buildExcludeRegionIds(request, regionIds) {
        request.excludeRegionIds = regionIds;
    },
    buildRegionIds(request, regionIds) {
        request.regionIds = regionIds ? getUniqueNotEmptyElements(regionIds) : undefined;
    },
    buildRegionId(request, regionId) {
        request.regionId = regionId;
    },
    buildIds(request, ids) {
        request.ids = ids;
    },
    buildSportIds(request, sportIds) {
        request.sportIds = sportIds;
    },
    buildSportId(request, sportId) {
        request.sportId = sportId;
    },
    buildDateRange(request, dateRange) {
        request.dateRange = dateRange;
    },
    buildEventTags(request, eventTags = []) {
        request.eventTags = eventTags;
    },
    buildSort(request, shouldBuildSort, sort) {
        if (request.dateRange && shouldBuildSort) {
            request.sort = sort;
        }
    },
    buildMarketTypeRequests(params, sportIds = []) {
        const marketTypeRequests = [];
        const defaultMarkets = this.buildMarketIds(params.request.eventState, params.cardConfiguration["0"].markets);
        const defaultConfiguration = {
            sportIds: [],
            marketTypeIds: defaultMarkets,
            statement: "Include"
        };
        let sportIdsToExclude = [];
        if (!sportIds.length) {
            sportIds = Object.keys(params.cardConfiguration).filter(k => k !== "0");
            sportIdsToExclude = Object.keys(params.cardConfiguration).filter(k => k !== "0");
        }
        sportIds.forEach(sportId => {
            const config = params.cardConfiguration[sportId];
            if (!config) {
                defaultConfiguration.sportIds.push(sportId);
            }
            else {
                const marketTypeIds = this.buildMarketIds(params.request.eventState, config.markets);
                if (sportIdsToExclude.length && compareArrays(marketTypeIds, defaultMarkets)) {
                    var index = sportIdsToExclude.indexOf(sportId);
                    index > -1 && sportIdsToExclude.splice(index, 1);
                }
                else {
                    marketTypeRequests.push({
                        sportIds: [sportId],
                        marketTypeIds,
                        statement: "Include"
                    });
                }
            }
        });
        params.request.marketTypeRequests = marketTypeRequests;
        sportIdsToExclude.length && params.request.marketTypeRequests.push({
            sportIds: sportIdsToExclude,
            marketTypeIds: defaultConfiguration.marketTypeIds,
            statement: "Exclude"
        });
        if (defaultConfiguration.sportIds.length || !params.request.marketTypeRequests.length) {
            defaultConfiguration.sportIds = this.buildDefaultSportIds(defaultConfiguration.sportIds, sportIds);
            params.request.marketTypeRequests.push(defaultConfiguration);
        }
    },
    buildMarketIds(eventState, markets) {
        return !eventState || eventState === EventsFromTopLeaguesBySportIdRequest.EventStateEnum.Mixed
            ? markets.map(m => m.idLive).concat(markets.map(m => m.idPreLive)).filter((value, index, self) => self.indexOf(value) === index)
            : markets.map(m => m[`id${eventState}`]);
    },
    buildDefaultSportIds(defaultIds, sportIds) {
        return defaultIds.length === sportIds.length ? [] : defaultIds;
    },
    buildMarketIdsByType(params, sportIds) {
        if (params.request.eventTypes && params.request.eventTypes.indexOf(EventsBySportIdRequest.EventTypesEnum.Outright) > -1) {
            return;
        }
        this.buildMarketTypeRequests(params, sportIds);
    },
    buildMarketIdByType(params, selectedMarketIds, sportIds) {
        this.buildMarketIdsByType(params, sportIds);
        if (params.request.marketTypeRequests) {
            Object.keys(params.request.marketTypeRequests).map(requestId => {
                const marketTypeRequest = params.request.marketTypeRequests[requestId];
                marketTypeRequest.marketTypeIds = selectedMarketIds;
            });
        }
    }
};
//# sourceMappingURL=requestBuilder.js.map